<router-outlet></router-outlet>
<app-confirm-modal *ngIf="confirmDialog.isOpen === true"></app-confirm-modal>
<app-display-modal *ngIf="!confirmDialog.isOpen" ></app-display-modal>
